import React, { useRef, useCallback, useState } from "react";
import { SECTIONS } from "../PlayerSection/PlayerSection";
import { RightClickMenu } from "../../Commons/RightClickMenuArea";

export default function DeckInteractionZone({
  deck,
  isOpponentDeck,
  playerId,
  topCardHiddenTo,
  setFocusedCard,
  createDraggedCard,
  setDeck,
  deckClick,
  menu,
  cardDraggedRef,
  leftClickText,
  draggedReplacementText,
  ...props
}) {

  // RIGHT CLICK
  const [isMenuVisible, setMenuVisible] = useState(false)
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 })
  const [isHover, setIsHover] = useState(false)
  const [replaceLeftClickText, setReplaceLeftClickText] = useState(false)

  // HOLD
  const timerRef = useRef(null);
  const heldRef = useRef(false);
  const eventRef = useRef(null);


  const handlePointerEnter = useCallback(() => {
    setIsHover(true)
    if (cardDraggedRef && cardDraggedRef.current) {
      if (draggedReplacementText) {
        setReplaceLeftClickText(true)
      }
    }

    if (topCardHiddenTo[playerId] !== true && deck.length > 0) {
      const card = deck.at(-1);
      card.position = {
        cardSize: { width: 8, height: 15 },
        section: SECTIONS.DECK
      };
      setFocusedCard({ card });
    }
  }, [deck, playerId, topCardHiddenTo, setFocusedCard]);

  const handlePointerLeave = useCallback(() => {
    setFocusedCard(false);
    clearTimeout(timerRef.current);
    setIsHover(false)
    setReplaceLeftClickText(false)
  }, [setFocusedCard]);



  function handleMouseDown(e) {
    if (e && e.pointerType === 'mouse' && e.button === 2) {
      e.preventDefault();
      setMenuPosition({ top: e.pageY, left: e.pageX });
      setMenuVisible(true);
    } else {
      heldRef.current = false;
      eventRef.current = e;
      timerRef.current = setTimeout(() => {
        heldRef.current = true;
        handleHold(eventRef.current);
      }, 200); // 200ms threshold
    }
  }

  const handleMouseUp = (e) => {
    clearTimeout(timerRef.current);
    setReplaceLeftClickText(false)
    if (e && e.pointerType === 'mouse' && e.button !== 2) {
      if (!heldRef.current && cardDraggedRef && !cardDraggedRef.current) {
        handleClick(); // trigger normal click
      }
    }
  };

  const handleClick = useCallback(() => {
    if (!isOpponentDeck) deckClick();
  }, [isOpponentDeck, deckClick]);

  const handleHold = useCallback((e) => {
    if (!isOpponentDeck && deck.length > 0) {
      const tmpDeck = [...deck];
      const card = tmpDeck.pop();
      createDraggedCard(card, e);
      setDeck(tmpDeck);
    }
  }, [isOpponentDeck, deck, createDraggedCard, setDeck]);

  return (
    <div
      className="interaction-zone right-click position-absolute top-0 start-0 w-100 h-100"
      onContextMenu={(e) => {
        e.preventDefault();
      }}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      onMouseLeave={handlePointerLeave}
      onTouchCancel={handlePointerLeave}
    >
      <div className={`left-click-info position-absolute top-0 start-0 h-100 w-100 ${isHover ? "hovered" : ""}`}
        onPointerDown={handleMouseDown}
        onPointerUp={handleMouseUp}
      >
        <div className="position-absolute top-0 start-0 h-100 w-100"></div>
        <p className="position-absolute top-0 w-100">{replaceLeftClickText ? draggedReplacementText : leftClickText}</p>
      </div>
      {isMenuVisible && (<RightClickMenu position={menuPosition} show={isMenuVisible} close={() => setMenuVisible(false)}>
        {menu}
      </RightClickMenu>)}
    </div>

  );
}